var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('content-section');
import { breakpoints, theme } from '@shapeable/theme';
import { ContentTitle } from './content-title';
import { useLang } from '../hooks/use-lang';
export var ContentSectionDefaultProps = {
  showDivider: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: ", " ", ";\n\n    ", "\n\n    &:first-child {\n      padding-top: 0;\n    }\n\n    &:last-child {\n      background: none;\n    }\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: ", " ", ";\n\n    ", "\n\n    &:first-child {\n      padding-top: 0;\n    }\n\n    &:last-child {\n      background: none;\n    }\n  "])), theme.UNIT(4), theme.UNIT(3), function (props) {
    return props.showDivider && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", ";\n      padding-bottom: ", ";\n    "], ["\n      ", ";\n      padding-bottom: ", ";\n    "])), theme.H_DOT_BG_END(), theme.UNIT(4, 2));
  })
});
var TitleStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled.section(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Title: styled(ContentTitle).attrs(cls.attr('title'))(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles)
};
export var ContentSection = function (props) {
  var className = props.className,
    title = props.title,
    children = props.children,
    showDivider = props.showDivider;
  var t = useLang();
  return React.createElement(My.Container, {
    showDivider: showDivider,
    className: cls.name(className)
  }, title && React.createElement(My.Title, null, t(title)), children);
};
ContentSection.cls = cls;
ContentSection.defaultProps = ContentSectionDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;